import React, { createContext, useContext, useReducer, useEffect } from 'react';
// import process from 'process';
import Papa from 'papaparse';

const BASE_API_URL = import.meta.env.VITE_API_URL;

const initialState = {
	plantData: [],
	loading: true,
	error: null,
};

const SET_PLANT_DATA = 'SET_PLANT_DATA';
const SET_LOADING = 'SET_LOADING';
const SET_ERROR = 'SET_ERROR';

const reducer = (state, action) => {
	switch (action.type) {
		case SET_PLANT_DATA:
			return { ...state, plantData: action.payload };
		case SET_LOADING:
			return { ...state, loading: action.payload };
		case SET_ERROR:
			return { ...state, error: action.payload };
		default:
			return state;
	}
};

const SpreadsheetContext = createContext();

export const SpreadsheetProvider = ({ children }) => {
	const [state, dispatch] = useReducer(reducer, initialState);

	useEffect(() => {
		const fetchSpreadsheetData = async () => {
			dispatch({ type: SET_LOADING, payload: true });
			try {
				const response = await fetch(`${BASE_API_URL}/csv`);
				if (!response.ok) {
					throw new Error('Error fetching spreadsheet data');
				}

				const data = await response.json();

				console.log(data);

				dispatch({ type: SET_PLANT_DATA, payload: data });
				dispatch({ type: SET_LOADING, payload: false });
			} catch (error) {
				dispatch({ type: SET_ERROR, payload: error.message });
				dispatch({ type: SET_LOADING, payload: false });
			}
		};

		fetchSpreadsheetData();
	}, []);

	return (
		<SpreadsheetContext.Provider
			value={{
				plantData: state.plantData,
				loading: state.loading,
				error: state.error,
			}}>
			{children}
		</SpreadsheetContext.Provider>
	);
};

export const useSpreadsheetContext = () => useContext(SpreadsheetContext);

export { SET_PLANT_DATA, SET_LOADING, SET_ERROR, SpreadsheetContext };
